import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: ginlime
 * id 3F3EFD86-07D4-495B-9E20-66826FF54E1D
 * name arrow-top-left-bottom-right
 * version: 3.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-top-left-bottom-right.svg
 * tags
 * - Arrow 
 */
export const ArrowTopLeftBottomRightIcon = createSvgIcon(<><path d="M13,21H21V13H19V17.59L6.41,5H11V3H3V11H5V6.41L17.59,19H13V21Z" /></>, 'ArrowTopLeftBottomRightIcon');
export default ArrowTopLeftBottomRightIcon